/** The first letters of the first two words, for a salon's monogram or a customer's avatar: "Green Trends Velachery" → "GT". */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
}
